export default __webpack_public_path__ + "static/media/prePost.b9bb54f1.svg";